package nl.astraeus.wiki.messages

import nl.astraeus.wiki.domain.User

class LoginMessage() : Message(
  MessageType.LOGIN,
  MessageHeader.EMAIL,
  MessageHeader.PASSWORD,
) {

  constructor(msg: String) : this() {
    this.message = msg
  }

  constructor(
    email: String,
    password: String
  ) : this() {
    setHeader(MessageHeader.EMAIL, email)
    setHeader(MessageHeader.PASSWORD, password)
  }

}

class LoginSuccessfulMessage() : Message(
  MessageType.LOGIN_SUCCESS,
  MessageHeader.OBJECT_ID,
  MessageHeader.EMAIL,
  MessageHeader.USERNAME,
) {
  constructor(msg: String) : this() {
    this.message = msg
  }

  constructor(
    msgId: String,
    user: User
  ) : this() {
    setHeader(MessageHeader.MESSAGE_ID, msgId)
    setHeader(MessageHeader.OBJECT_ID, user.id.toString())
    setHeader(MessageHeader.EMAIL, user.email)
    setHeader(MessageHeader.USERNAME, user.name)
  }
}

class LoginFailedMessage() : Message(
  MessageType.LOGIN_FAILURE,
) {
  constructor(msg: String) : this() {
    this.message = msg
  }
}

class LogoutMessage() : Message(
  MessageType.LOGOUT,
)

class LogoutSuccessfulMessage() : Message(
  MessageType.LOGOUT_SUCCESS,
) {
  constructor(
    msgId: String,
  ) : this() {
    setHeader(MessageHeader.MESSAGE_ID, msgId)
  }
}

